/* global $, */
const MAIN_TABS = {
    'about-me': 'about',
    'about-the-team': 'about',
    'contact-us': 'about',
    'insurance': 'insurance',
    'stories-and-articles': 'news',
    'events': 'news'
};

// Gets the current path name so we can set the placement of the roof item under the active tab
export const getActiveTab = (parsedUrl) => {
    const pageArray = parsedUrl.pathname.split('/');
    const mainTabsKeys = Object.keys(MAIN_TABS);
    const activeTabKey = pageArray.filter(part => mainTabsKeys.indexOf(part) !== -1)[0];

    return MAIN_TABS[activeTabKey] || 'home';
};

export const getTargetTabElementId = (targetTab, parsedUrl) => (
    targetTab ? `#main-nav-${targetTab}` : `#main-nav-${getActiveTab(parsedUrl)}`
);

export const getRooflineOffsetWidth = (activeTab, rooflineImgWidth) => (
    activeTab.getBoundingClientRect().left + (activeTab.offsetWidth / 2) - (rooflineImgWidth / 2)
);

// Sets the position of the red line rooftop on desktop nav
// activeTab: used for hover. If not passed in, position set to tab that matches web page path
export const setRooftopPosition = (targetTab, parsedUrl) => {
    const rooflineImgWidth = document.querySelector('#top-roofline .roofline-img').offsetWidth;
    const activeTab = document.querySelector(getTargetTabElementId(targetTab, parsedUrl));

    if(activeTab) {
        document.querySelector('#mover').style.width = `${getRooflineOffsetWidth(activeTab, rooflineImgWidth)}px`;
    }
};



// WEBPACK FOOTER //
// ./js/nav/set-rooftop-position.js